<!-- 订单审核 -->
<template>
  <div class="diseaseList">
    <!-- 顶部操作栏：搜索 + 新增，与表格拼接成整块白卡 -->
    <div class="action-bar">
      <div class="action-left">
        <div class="search-group">
          <el-input
            class="search-input"
            v-model="listQuery.phone"
            placeholder="搜索下单人手机号"
            prefix-icon="el-icon-search"
            size="small"
            clearable
            @keyup.enter.native="handleSearch"
            @clear="handleSearch"
          ></el-input>
          <el-button class="btn-search" size="small" @click="handleSearch"
            >搜索</el-button
          >
        </div>
        <el-button class="btn-add" type="primary" @click="handleAdd"
          >新增订单</el-button
        >
      </div>
      <div class="action-meta">
        共 <span class="meta-num">{{ listQuery.total || 0 }}</span> 条订单
      </div>
    </div>

    <div class="tableList">
      <!-- 封装表单table组件 -->
      <ElTable
        :columns="listHeader"
        :tableData="tableData"
        :loading="loading"
        :total="listQuery.total"
        header-bg-color="#F1F6FC"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      >
        <template slot="status" slot-scope="{ row }">
          <span class="status-chip" :class="'status-' + row.status">{{
            statusText(row.status)
          }}</span>
        </template>
        <template slot="openid" slot-scope="{ row }">
          <el-tooltip
            :content="row.openid"
            placement="top"
            :disabled="!row.openid"
          >
            <span class="cell-text">{{ row.openid || "—" }}</span>
          </el-tooltip>
        </template>
        <template slot="money" slot-scope="{ row }">
          <span class="money-text">¥{{ formatMoney(row.money) }}</span>
        </template>
        <template slot="msg" slot-scope="{ row }">
          <el-tooltip :content="row.msg" placement="top" :disabled="!row.msg">
            <span class="cell-text">{{ row.msg || "—" }}</span>
          </el-tooltip>
        </template>
        <template slot="remark" slot-scope="{ row }">
          <el-tooltip
            :content="row.remark"
            placement="top"
            :disabled="!row.remark"
          >
            <span class="cell-text">{{ row.remark || "—" }}</span>
          </el-tooltip>
        </template>
        <template slot="out_trade_no" slot-scope="{ row }">
          <el-tooltip
            :content="row.out_trade_no"
            placement="top"
            :disabled="!row.out_trade_no"
          >
            <span class="cell-text">{{ row.out_trade_no || "—" }}</span>
          </el-tooltip>
        </template>
        <template slot="transaction_id" slot-scope="{ row }">
          <el-tooltip
            :content="row.transaction_id"
            placement="top"
            :disabled="!row.transaction_id"
          >
            <span class="cell-text">{{ row.transaction_id || "—" }}</span>
          </el-tooltip>
        </template>
        <template slot="operation" slot-scope="{ row }">
          <div class="operation">
            <el-button size="mini" class="op-edit" @click="handleEdit(row)"
              >编辑</el-button
            >
            <el-button size="mini" class="op-delete" @click="handleDelete(row)"
              >删除</el-button
            >
          </div>
        </template>
      </ElTable>
    </div>

    <!-- 右侧滑出抽屉表单 -->
    <el-drawer
      :title="dialogName"
      :visible.sync="dialogVisible"
      direction="rtl"
      size="480px"
      :wrapper-closable="false"
      custom-class="order-drawer"
    >
      <el-form ref="form" :model="dialogForm" class="order-form">
        <div class="drawer-body">
          <!-- 状态概览 -->
          <div class="status-banner">
            <span
              class="status-dot"
              :class="'dot-' + dialogForm.status"
            ></span>
            <span class="status-text">{{
              statusText(dialogForm.status)
            }}</span>
            <span class="status-desc">当前订单状态</span>
          </div>

          <!-- 订单信息 -->
          <div class="form-card">
            <div class="card-title">订单信息</div>
            <div class="field-item">
              <div class="field-label">订单状态</div>
              <el-select
                v-model="dialogForm.status"
                placeholder="请选择订单状态"
                clearable
                class="full-select"
              >
                <el-option
                  v-for="item in roleList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </div>
            <div class="field-item">
              <div class="field-label">金额（元）</div>
              <el-input
                class="money-input"
                v-model="dialogForm.money"
                placeholder="请输入金额"
                clearable
              >
                <span slot="prefix" class="money-prefix">¥</span>
              </el-input>
            </div>
          </div>

          <!-- 客户信息 -->
          <div class="form-card">
            <div class="card-title">客户信息</div>
            <div class="field-item">
              <div class="field-label">手机号</div>
              <el-input
                v-model="dialogForm.phone"
                placeholder="请输入下单人手机号"
                clearable
              ></el-input>
            </div>
            <div class="field-item">
              <div class="field-label">openid</div>
              <el-input
                v-model="dialogForm.openid"
                placeholder="请输入 openid"
                clearable
              ></el-input>
            </div>
          </div>

          <!-- 补充信息 -->
          <div class="form-card">
            <div class="card-title">补充信息</div>
            <div class="field-item">
              <div class="field-label">订单描述</div>
              <el-input
                class="desc-input"
                type="textarea"
                :rows="3"
                v-model="dialogForm.msg"
                placeholder="请输入订单描述"
              ></el-input>
            </div>
            <div class="field-item">
              <div class="field-label">备注</div>
              <el-input
                class="desc-input"
                type="textarea"
                :rows="2"
                v-model="dialogForm.remark"
                placeholder="请输入备注"
              ></el-input>
            </div>
          </div>
        </div>
      </el-form>
      <div class="drawer-footer">
        <el-button class="btn-cancel" @click="dialogVisible = false"
          >取 消</el-button
        >
        <el-button class="btn-confirm" type="primary" @click="save"
          >确 定</el-button
        >
      </div>
    </el-drawer>
  </div>
</template>

<script>
import ElTable from "@/components/elTable/index.vue";
import listHeader from "./listHeader";
import {
  addOrder,
  updateOrder,
  selectOrder,
  deleteOrder,
} from "@/services/plus/order";
export default {
  components: {
    ElTable,
  },
  async created() {
    this.getListData();
  },
  data() {
    return {
      loading: false,
      listQuery: {
        pageNumber: 1,
        pageSize: 10,
        total: 0,
        /* 手机号搜索 */
        phone: "",
      },
      /* 表格数据 */
      tableData: [],
      /* 弹窗 */
      dialogName: "",
      dialogVisible: false,
      dialogForm: {},
      roleList: [
        { id: 0, name: "待处理" },
        { id: 1, name: "已处理" },
      ],
    };
  },
  computed: {
    listHeader,
  },
  watch: {},
  methods: {
    /* 状态文案 */
    statusText(status) {
      if (status === 0 || status === "0") return "待处理";
      if (status === 1 || status === "1") return "已处理";
      return "——";
    },
    /* 金额格式化：保留两位小数 */
    formatMoney(val) {
      if (val === null || val === undefined || val === "") return "0.00";
      const n = Number(val);
      return isNaN(n) ? val : n.toFixed(2);
    },
    async getListData(listQuery) {
      this.loading = true;
      const { data, code, count } = await selectOrder(
        listQuery || this.listQuery
      );
      if (code === 200) {
        this.tableData = data;
        this.listQuery.total = count;
        setTimeout(() => {
          this.loading = false;
        }, 600);
      }
    },
    /* 搜索：回到第 1 页 */
    handleSearch() {
      this.listQuery.pageNumber = 1;
      this.getListData();
    },

    /* 新增 */
    handleAdd() {
      this.dialogVisible = true;
      this.dialogName = "创建订单";
      this.dialogForm = {};
    },

    /* 修改 */
    handleEdit(row) {
      this.dialogVisible = true;
      this.dialogName = "编辑订单";
      this.dialogForm = JSON.parse(JSON.stringify(row));
    },

    /* 保存 */
    save() {
      if (this.dialogName === "创建订单") {
        addOrder(this.dialogForm).then((res) => {
          if (res.code === 200) {
            this.listQuery.pageNumber = 1;
            this.getListData();
            this.$message({
              type: "success",
              message: "创建成功!",
            });
            this.dialogVisible = false;
          }
        });
      }
      if (this.dialogName === "编辑订单") {
        updateOrder(this.dialogForm).then((res) => {
          if (res.code === 200) {
            this.getListData();
            this.$message({
              type: "success",
              message: "编辑成功!",
            });
            this.dialogVisible = false;
          }
        });
      }
    },

    /* 删除 */
    handleDelete(row) {
      this.$confirm("此操作将永久删除该订单, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteOrder({ id: row.id }).then(() => {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.getListData();
          });
        })
        .catch(() => {});
    },

    /* 分页 */
    handleCurrentChange(e) {
      this.listQuery.pageNumber = e;
      this.getListData();
    },
    handleSizeChange(e) {
      this.listQuery.pageSize = e;
      this.getListData();
    },
  },
};
</script>

<style scoped lang="less">
.diseaseList {
  width: 100%;
}

/* 顶部操作栏：白卡上半部，与表格拼接 */
.action-bar {
  background: #fff;
  border-radius: 8px 8px 0 0;
  padding: 16px 16px 12px;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .action-left {
    display: flex;
    align-items: center;
  }
  /* 输入框与搜索按钮拼接成一体，弱化次要操作 */
  .search-group {
    display: flex;
    align-items: center;

    /deep/ .search-input .el-input__inner {
      height: 32px;
      line-height: 32px;
      border-radius: 6px 0 0 6px;
    }
    .btn-search {
      height: 32px;
      margin-left: -1px;
      padding: 0 16px;
      font-size: 14px;
      color: #3d8dfc;
      background: #fff;
      border: 1px solid #dcdfe6;
      border-radius: 0 6px 6px 0;
      transition: all 0.2s;

      &:hover {
        color: #2f7be0;
        background: #f3f8ff;
        border-color: #3d8dfc;
        position: relative;
        z-index: 1;
      }
    }
  }
  .search-input {
    width: 220px;
  }
  /* 主按钮：实心蓝 */
  .btn-add {
    height: 32px;
    margin-left: 12px;
    padding: 0 16px;
    font-size: 14px;
    color: #fff;
    background: #3d8dfc;
    border: 1px solid #3d8dfc;
    border-radius: 6px;
    box-shadow: 0 2px 6px rgba(61, 141, 252, 0.3);
    transition: all 0.2s;

    &:hover {
      background: #2f7be0;
      border-color: #2f7be0;
      box-shadow: 0 4px 10px rgba(61, 141, 252, 0.4);
    }
    &:active {
      background: #2a6ecb;
      border-color: #2a6ecb;
    }
  }

  /* 右侧统计信息，平衡一行视觉重心 */
  .action-meta {
    font-size: 13px;
    color: #8a94a6;

    .meta-num {
      color: #3d8dfc;
      font-weight: 600;
    }
  }
}

/* 表格区：白卡下半部 */
.tableList {
  border-radius: 0 0 8px 8px;
  background: #fff;
  padding: 12px 16px 16px;

  /* 单元格不换行，超出显示省略号 */
  /deep/ .el-table .cell {
    white-space: nowrap;
  }

  /* 单元格文本：单行省略，悬浮可看全文 */
  .cell-text {
    display: inline-block;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: middle;
  }
}

/* 订单状态：浅色底小标签 */
.status-chip {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 10px;
  border-radius: 4px;
  font-size: 12px;
  /* 无状态时兜底为灰色标签 */
  background: #f2f3f5;
  color: #86909c;

  &.status-0 {
    background: #fdf3e1;
    color: #e6a23c;
  }
  &.status-1 {
    background: #e8f8ee;
    color: #00b42a;
  }
}

/* 金额：品牌蓝强调 */
.money-text {
  font-size: 14px;
  font-weight: 600;
  color: #3d8dfc;
}

/* 操作列：编辑蓝字 / 删除红字 */
.operation {
  display: flex;
  align-items: center;
  gap: 8px;

  .el-button {
    margin: 0;
    padding: 0 8px;
    height: 24px;
    line-height: 1;
    font-size: 13px;
    border: none;
    background: transparent;
    box-sizing: border-box;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: color 0.15s ease;
  }
  .op-edit {
    color: #3d8dfc;

    &:hover {
      color: #2f7be0;
    }
  }
  .op-delete {
    color: #f53f3f;
    border-left: 1px solid #e5e6eb;
    margin-left: 6px;
    padding-left: 14px;

    &:hover {
      color: #ff7875;
    }
  }
}

/* 右侧滑出抽屉：浅灰底 + 白色分组卡片 */
/deep/ .el-drawer__body {
  position: relative;
  padding: 0 0 72px;
  background: #f6f8fb;
}
/deep/ .order-drawer .el-drawer__header {
  padding: 18px 20px;
  margin-bottom: 0;
  color: #1d2129;
  font-size: 16px;
  font-weight: 600;
  border-bottom: 1px solid #f0f1f3;
}
/deep/ .order-drawer .el-drawer__close-btn {
  color: #86909c;
}

.drawer-body {
  height: 100%;
  max-height: calc(100vh - 140px);
  overflow-y: auto;
  padding: 16px 16px 0;
}

/* 状态概览条 */
.status-banner {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 44px;
  padding: 0 16px;
  margin-bottom: 14px;
  background: #fff;
  border: 1px solid #eef1f6;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(29, 33, 41, 0.04);

  .status-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #c9cdd4;

    &.dot-0 {
      background: #e6a23c;
      box-shadow: 0 0 0 3px rgba(230, 162, 60, 0.16);
    }
    &.dot-1 {
      background: #00b42a;
      box-shadow: 0 0 0 3px rgba(0, 180, 42, 0.16);
    }
  }
  .status-text {
    font-size: 14px;
    font-weight: 600;
    color: #1d2129;
  }
  .status-desc {
    margin-left: auto;
    font-size: 12px;
    color: #a9aeb8;
  }
}

/* 分组卡片 */
.form-card {
  background: #fff;
  border: 1px solid #eef1f6;
  border-radius: 14px;
  padding: 16px 18px;
  margin-bottom: 14px;
  box-shadow: 0 1px 3px rgba(29, 33, 41, 0.04);
}
.card-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #1d2129;
  margin-bottom: 14px;
  letter-spacing: 0.3px;

  &::before {
    content: "";
    width: 3px;
    height: 13px;
    border-radius: 2px;
    background: #3d8dfc;
  }
}

/* 字段 */
.field-item {
  margin-bottom: 14px;
}
.field-label {
  font-size: 13px;
  font-weight: 500;
  color: #4e5969;
  margin-bottom: 6px;
  letter-spacing: 0.3px;
}
.field-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}
.full-select {
  width: 100%;
}

/* 输入框：白底细边，聚焦蓝色描边 */
.order-form /deep/ .el-input__inner {
  background: #fff;
  border: 1px solid #e5e6eb;
  border-radius: 10px;
  height: 42px;
  line-height: 42px;
  color: #1d2129;
  font-size: 14px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    border-color: #c9cdd4;
  }
  &:focus {
    border-color: #3d8dfc;
    box-shadow: 0 0 0 3px rgba(61, 141, 252, 0.12);
  }
  &::placeholder {
    color: #a9aeb8;
  }
}

/* 下拉：箭头减淡，与输入框风格统一 */
.order-form /deep/ .el-select .el-input__suffix {
  color: #a9aeb8;
}
.order-form /deep/ .el-select .el-input .el-select__caret {
  color: #a9aeb8;
}

/* 金额：¥ 前缀 */
.money-input {
  /deep/ .el-input__prefix {
    left: 12px;
    /* 前缀默认不居中，用 flex 让 ¥ 与输入文字同一基线 */
    display: flex;
    align-items: center;
    height: 100%;
  }
  /deep/ .el-input__inner {
    padding-left: 32px;
    color: #3d8dfc;
    font-weight: 600;
  }
}
.money-prefix {
  color: #86909c;
  font-size: 14px;
}

/* 多行输入 */
.desc-input /deep/ .el-textarea__inner {
  background: #fff;
  border: 1px solid #e5e6eb;
  border-radius: 10px;
  padding: 12px 14px;
  color: #1d2129;
  font-size: 14px;
  font-family: inherit;
  line-height: 22px;
  resize: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    border-color: #c9cdd4;
  }
  &:focus {
    border-color: #3d8dfc;
    box-shadow: 0 0 0 3px rgba(61, 141, 252, 0.12);
  }
  &::placeholder {
    color: #a9aeb8;
  }
}

/* 底部固定操作栏 */
.drawer-footer {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  padding: 14px 20px;
  border-top: 1px solid #f0f1f3;
  background: #fff;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  .btn-cancel,
  .btn-confirm {
    height: 38px;
    min-width: 104px;
    border-radius: 10px;
    font-size: 14px;
    padding: 0;
    transition: all 0.15s ease;
  }
  .btn-cancel {
    background: #fff;
    border: 1px solid #dcdee3;
    color: #4e5969;

    &:hover {
      color: #1d2129;
      border-color: #c9cdd4;
      background: #f7f8fa;
    }
  }
  .btn-confirm {
    background: #3d8dfc;
    border: 1px solid #3d8dfc;
    color: #fff;
    margin-left: 12px;

    &:hover {
      background: #2f7be0;
      border-color: #2f7be0;
    }
    &:active {
      background: #2a6ecb;
      border-color: #2a6ecb;
    }
  }
}
</style>
